 
 
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue  } from "vue-class-component";  
    import {  Prop } from 'vue-property-decorator';   
    import Multiselect from '@vueform/multiselect'
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    
    @Options({
        name: "ControladorEtapa5",
        components: {  CardRh , Multiselect },   
    }) 
    export default class ControladorEtapa5 extends Vue {
         
        public processando = false;  
        public ativo = false;  

        @Prop( ) readonly service!: any 
        @Prop( ) readonly turmas_que_controlo!: any 
        @Prop( ) readonly formData!: any 
           
        activated(){ 
            if (!this.formData.instrutorId || !this.formData.assunto ||!this.formData.numero  ) {  
                this.prevPage( );
            }
            this.ativo = true;
        }
        
        deactivated(){
            this.ativo = false;
        }
        
        formatData( data ){
            return SiteUtils.formatData( data );
        }
 
        public complete() {
            this.$emit('complete');
        }

        prevPage() {
            this.$emit('prevPage', {
                pageIndex: 3
            }); 
        } 
    } 
